import maintainRequest from "@/maintain/utils/maintainRequest";

export default function maintainGetAccessControlDeviceNumDateil() {
  return maintainRequest.get(
    `/device/maintenanceMan/accessDevice/getAccessControlDeviceNumDetail`
  );
}
